import { orderFaceBackgroundInMaker } from '../../../../Maker/F/util.js';

export const processBulkCvObjsAdd = async (addCvObj, _fcanvas) => {
  const fcanvas = _fcanvas || G.mp.maker.editing_canvas();
  fcanvas._is_bulk_added = true;
  await addCvObj();
  fcanvas._is_bulk_added = false;
  orderFaceBackgroundInMaker(fcanvas);
};
